/** Centered-top fade-in/out notification for area entries. One toast at a time, queued. */
export class AreaToast {
  private root: HTMLElement;
  private nameEl: HTMLElement;
  private tierEl: HTMLElement;
  private queue: Array<{ name: string; tier: string }> = [];
  private playing = false;
  private hideTimer: number | null = null;
  private nextTimer: number | null = null;

  constructor() {
    this.root = document.createElement('div');
    this.root.className = 'area-toast';
    this.tierEl = document.createElement('div');
    this.tierEl.className = 'area-toast-tier';
    this.nameEl = document.createElement('div');
    this.nameEl.className = 'area-toast-name';
    this.root.appendChild(this.tierEl);
    this.root.appendChild(this.nameEl);
    document.body.appendChild(this.root);
  }

  /** Queue a fade-in. `tier` is shown above the name as small uppercase label. */
  show(name: string, tier: string): void {
    this.queue.push({ name, tier });
    if (!this.playing) this.playNext();
  }

  private playNext(): void {
    const next = this.queue.shift();
    if (!next) {
      this.playing = false;
      return;
    }
    this.playing = true;
    this.nameEl.textContent = next.name;
    this.tierEl.textContent = next.tier;
    // Reflow trick: remove class, force reflow, re-add so the transition restarts cleanly.
    this.root.classList.remove('show');
    void this.root.offsetWidth;
    this.root.classList.add('show');
    if (this.hideTimer !== null) window.clearTimeout(this.hideTimer);
    if (this.nextTimer !== null) window.clearTimeout(this.nextTimer);
    this.hideTimer = window.setTimeout(() => {
      this.root.classList.remove('show');
    }, 2800);
    this.nextTimer = window.setTimeout(() => {
      this.playNext();
    }, 3400);
  }
}
